/* This file is autogenerated, see readme.md for instructions */
import ShrinkSvgIcon from '@bloomreach/banana-theme/icons/shrink.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ShrinkIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ShrinkSvgIcon />
    </Icon>
  );
});

ShrinkIcon.displayName = 'ShrinkIcon';

export default ShrinkIcon;
